import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

export interface Daily { day: string; n: number }

export function Sparkline({ data, color }: { data: Daily[]; color: string }) {
  const max = Math.max(1, ...data.map((d) => d.n));
  const pts = data.map((d, i) => `${(i / (data.length - 1)) * 100},${28 - (d.n / max) * 24}`).join(" ");
  return (
    <svg viewBox="0 0 100 30" className="h-8 w-full" preserveAspectRatio="none" aria-hidden>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

interface StatProps { label: string; value: number | string; sub: string; icon: LucideIcon; to: string; tone: string; testId: string; trend?: Daily[] }

export function StatCard({ label, value, sub, icon: Icon, to, tone, testId, trend }: StatProps) {
  return (
    <Link to={to} className="calm-card flex flex-col justify-between p-5" data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#23324A]/60">{label}</p>
        <span className="grid h-9 w-9 place-items-center rounded-xl" style={{ background: tone }}><Icon className="h-4 w-4 text-[#23324A]" strokeWidth={2.5} /></span>
      </div>
      <p className="mt-3 font-display text-4xl font-black text-[#23324A]" data-testid={`${testId}-value`}>{value}</p>
      {trend ? <Sparkline data={trend} color="#F08A6C" /> : null}
      <p className="mt-1 text-xs font-semibold text-[#23324A]/60">{sub}</p>
    </Link>
  );
}
